module.exports = __webpack_public_path__ + "img/gmailLogoWhite.2aa76815.svg";